import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import Button from '../Button';
import RawHTML from '../RawHTML';

export interface ToastProps {
  message: React.ReactNode | string;
  type: 'error' | 'info' | 'success' | 'warning';
  id?: string;
  dismissible?: boolean;
  icon?: React.ReactNode;
  ctaText?: string;
  ctaOnClick?: () => void;
  onClose?: () => void;
  duration?: number;
  show?: boolean;
  autoDismiss?: boolean;
}

function Toast(props: ToastProps) {
  const {
    message,
    type = 'info',
    dismissible,
    ctaText,
    onClose,
    ctaOnClick,
    show,
    duration = 6,
    autoDismiss = true,
  } = props;

  const [isShown, setShow] = useState(show);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (autoDismiss) {
        setShow(false);
      }
    }, duration * 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [autoDismiss, duration]);

  const toastClasses = classNames(
    'ui-toast',
    {
      'ui-toast--show': isShown,
    },
    `ui-toast--${type}`
  );

  return isShown ? (
    <div className={toastClasses} role="alert">
      <div className="ui-toast-message">
        {typeof message === 'string' ? <RawHTML>{message}</RawHTML> : message}
      </div>
      {ctaText && (
        <Button
          className="ui-toast-cta"
          color="reversed"
          size="small"
          onClick={ctaOnClick}
        >
          {ctaText}
        </Button>
      )}
      {dismissible && (
        <Button
          className="ui-toast-close-button"
          btnStyle="flat"
          onClick={onClose}
          iconOnly
          noPadding
          size="small"
          aria-label="close toast"
        >
          <Icon name="close" size="xx-small" />
        </Button>
      )}
    </div>
  ) : null;
}

export default Toast;
